export const getAcuitasNameInCorrectFormat = (name: string): string => {
  return name.split(',').reverse().join(' ');
};
